import { useGetInvoiceById } from "@entities/accounting/lib/hooks/useGetInvoiceById";
import { IGetPurchase } from "@entities/accounting/lib/types";
import { IBrandAccounting } from "@shared/lib/types/accounting";
import { Col, Form, Input, InputNumber, Modal, Row, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import styles from "./styles.module.scss";
interface ViewTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: IBrandAccounting | null;
}

export default function ViewCreditNoteModal({
  transaction,
  isOpen,
  onClose,
}: ViewTransactionModalProps) {
  const { invoice, isLoading } = useGetInvoiceById(
    transaction?._id || "",
    isOpen
  );

  const purchases = invoice?.brandLedgers;
  const [form] = Form.useForm();
  const summaryColumns: ColumnsType<IGetPurchase> = [
    {
      title: "Purchase Ref",
      dataIndex: "remarks",
      render: (text: string, record: IGetPurchase) => (
        <div>
          <div>{text}</div>
          <div style={{ fontSize: 11, color: "#888" }}>
            {new Date(record.createdAt).toLocaleDateString("en-GB")} •{" "}
            {record._id}
          </div>
        </div>
      ),
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      align: "right",
      render: (val: number, record) => (
        <span
          className={`${record.type === "Credit" ? styles.amountNegative : ""}`}
        >
          {record.type === "Credit" ? "-" : ""}₹{val.toLocaleString()}
        </span>
      ),
    },
  ];
  return (
    <Modal
      title="View Document"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      loading={isLoading}
    >
      <div className={styles.stepContent}>
        <div className={styles.summarySection}>
          <div className={styles.summaryHeader}>
            <h4 className={styles.summaryTitle}>Credit Note Summary</h4>
            <span className={styles.summaryMeta}>
              {purchases?.length} purchase(s)
            </span>
          </div>
          <div className={styles.creditNoteTable}>
            <Table
              size="small"
              className={styles.summaryTable}
              rowKey="_id"
              columns={summaryColumns}
              dataSource={purchases}
              pagination={false}
              summary={() => (
                <Table.Summary.Row className={styles.summaryFooter}>
                  <Table.Summary.Cell index={0}>
                    Total Selected Purchases
                  </Table.Summary.Cell>
                  <Table.Summary.Cell
                    index={1}
                    align="right"
                    className={styles.summaryTotal}
                  >
                    ₹{transaction?.totalAmount}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              )}
            />
          </div>
        </div>

        <Form
          form={form}
          layout="vertical"
          className={styles.form}
          disabled
          requiredMark={false}
          initialValues={{
            cnNumber: transaction?.accountingNumber,
            cnDate: dayjs(transaction?.date).format("YYYY-MM-DD"),
            cnAmount: transaction?.totalAmount,
            cnReason: transaction?.remarks,
          }}
        >
          <Form.Item label="Credit Note">
            <a href={transaction?.url} target="_blank" rel="noreferrer">
              {transaction?.url}
            </a>
          </Form.Item>

          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                label="Credit Note Number"
                name="cnNumber"
                rules={[{ required: true }]}
              >
                <Input placeholder="CN-2024-001" />
              </Form.Item>
            </Col>
            <Col span={12}>
              {/* <Form.Item
                label="Credit Note Date"
                name="cnDate"
                rules={[{ required: true }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item> */}
            </Col>
          </Row>

          <Form.Item
            label="Reason for Credit Note"
            name="cnReason"
            rules={[{ required: true }]}
          >
            <Input.TextArea placeholder="Enter reason..." rows={3} />
          </Form.Item>

          <Form.Item label="Total Amount (Incl. Tax)" name="cnAmount">
            <InputNumber
              style={{ width: "100%" }}
              prefix="₹"
              placeholder="0.00"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value!.replace(/₹\s?|(,*)/g, "")}
            />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
}
